import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../components/FullScreenImagePage.css';

const BackgroundFullScreen = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const imageUrl = location.state?.backgroundImage;

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') navigate(-1);
        };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [navigate]);

    if (!imageUrl) {
        return (
            <div className="fullscreen-container">
                <p style={{ color: 'white' }}>No image provided.</p>
            </div>
        );
    }

    return (
        <div className="fullscreen-container" onClick={() => navigate(-1)}>
            <img src={imageUrl} alt="Background Fullscreen" className="fullscreen-image" />
        </div>
    );
};

export default BackgroundFullScreen;
